export const ACTION_PREFIX = 'PAYOUTS/COMMISSION_PLAN';
export const STATE_NAME = 'payoutsCommissionPlan';

export const Actions = {
  LOAD_COMMISSION_PLAN_START: `${ACTION_PREFIX}/LOAD_COMMISSION_PLAN_START`,
  LOAD_COMMISSION_PLAN_DONE: `${ACTION_PREFIX}/LOAD_COMMISSION_PLAN_DONE`,
  LOAD_COMMISSION_PLAN_FAIL: `${ACTION_PREFIX}/LOAD_COMMISSION_PLAN_FAIL`,
};
